const LOAD_CALCULATOR_UTILITIES = [
  "PEPCO",
  "Delmarva",
  "ACE",
  "JCP&L",
  "OR",
  "PSE&G",
  "LIPA",
  "PSEGLI",
];

export { LOAD_CALCULATOR_UTILITIES };
